import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Landed here from Google with #session_id=... — exchange it for our session, then go home. */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleSession } = useAuth();
  const processed = useRef(false);
  const [failed, setFailed] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      const result = sessionId ? await googleSession(sessionId) : { ok: false, error: "Missing sign-in session." };
      if (result.ok) {
        if (result.isNew) localStorage.setItem("pins:show-onboarding", "1");
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user: result.user } });
      } else {
        setFailed(result.error || "Sign-in failed.");
      }
    })();
  }, [location.hash, googleSession, navigate]);

  return (
    <div className="min-h-screen bg-[#f7f5f0] flex items-center justify-center p-8" data-testid="auth-callback">
      {failed ? (
        <div className="max-w-sm text-center">
          <p className="overline">Sign in</p>
          <p className="mt-3 font-serif text-2xl">We couldn't complete Google sign-in.</p>
          <p className="mt-2 text-sm text-[#963f2b] font-mono" data-testid="auth-callback-error">{failed}</p>
          <button
            className="btn-primary mt-6"
            data-testid="auth-callback-back"
            onClick={() => {
              window.history.replaceState(null, "", "/login");
              navigate("/login", { replace: true });
            }}
          >
            Back to sign in
          </button>
        </div>
      ) : (
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#5c5c5c]">Stamping your passport…</p>
      )}
    </div>
  );
}
